<template>
  <div class="gas-cylinder-detection">
    <!-- Hero Section -->
    <section class="hero-section" :style="{backgroundImage: `url(${require('@/assets/bg3.png')})`}">
      <div class="hero-overlay"></div>
      <div class="container">
        <div class="hero-content">
          <div class="content-left">
            <h1 class="hero-title">气瓶定期检验</h1>
            <p class="hero-subtitle">专业气瓶检测服务，保障压力容器使用安全</p>
            <p class="hero-description">
              我们提供全面的空气呼吸器用碳纤维缠绕式复合气瓶定期检验服务，严格按照<br />
              国家标准GB 24161-2009规范执行，确保每一只气瓶都符合安全使用要求。
            </p>
            <button class="btn-primary">立即预约检测</button>
          </div>
          <div class="content-right">
            <div class="hero-image">
              <img src="@/assets/qiping.jpg" alt="气瓶检测设备" />
              <div class="badge">
                <img src="@/assets/air-breathing/image-4.png" alt="图标" class="badge-icon" />
                <span>国家级检测资质</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 基本信息区域 -->
    <section class="info-section">
      <div class="container">
        <div class="info-grid">
          <div class="info-card">
            <div class="info-header">
              <i class="el-icon-info"></i>
              <h3>使用范围</h3>
            </div>
            <div class="info-body">
              <p>适用于空气呼吸器用碳纤维缠绕式复合气瓶的检验。</p>
            </div>
          </div>

          <div class="info-card">
            <div class="info-header">
              <i class="el-icon-time"></i>
              <h3>检验周期</h3>
            </div>
            <div class="info-body">
              <p>复合气瓶的定期检验周期一般每三年检验一次，具体按GB 24161-2009 4.2规定执行。</p>
            </div>
          </div>

          <div class="info-card">
            <div class="info-header">
              <i class="el-icon-document-checked"></i>
              <h3>检验项目</h3>
            </div>
            <div class="info-body">
              <p>复合气瓶定期检验项目包括：外观检查、内部检查、瓶口检查、水压试验、内部干燥、瓶阀检验和气密性试验。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 检验流程 Section -->
    <section class="process-section">
      <div class="container">
        <h2 class="section-title">检验流程</h2>
        <div class="process-flow">
          <!-- 第一行 -->
          <div class="flow-row">
            <div class="flow-item">
              <div class="flow-number">01</div>
              <div class="flow-content">
                <h4>接受检验任务</h4>
              </div>
            </div>
            <div class="flow-arrow">→</div>
            
            <div class="flow-item">
              <div class="flow-number">02</div>
              <div class="flow-content">
                <h4>检验前准备</h4>
              </div>
            </div>
            <div class="flow-arrow">→</div>
            
            <div class="flow-item">
              <div class="flow-number">03</div>
              <div class="flow-content">
                <h4>外观检查</h4>
              </div>
            </div>
            <div class="flow-arrow">→</div>
            
            <div class="flow-item">
              <div class="flow-number">04</div>
              <div class="flow-content">
                <h4>内部检查</h4>
              </div>
            </div>
            <div class="flow-arrow">→</div>
            
            <div class="flow-item">
              <div class="flow-number">05</div>
              <div class="flow-content">
                <h4>瓶口检查</h4>
              </div>
            </div>
          </div>

          <!-- 连接箭头 -->
          <div class="flow-connector right-to-right">
            <div class="connector-arrow">↓</div>
          </div>

          <!-- 第二行 -->
          <div class="flow-row reverse-desktop">
            <div class="flow-item final">
              <div class="flow-number">10</div>
              <div class="flow-content">
                <h4>出具检验报告</h4>
              </div>
            </div>
            <div class="flow-arrow">←</div>
            
            <div class="flow-item">
              <div class="flow-number">09</div>
              <div class="flow-content">
                <h4>气密性试验</h4>
              </div>
            </div>
            <div class="flow-arrow">←</div>
            
            <div class="flow-item">
              <div class="flow-number">08</div>
              <div class="flow-content">
                <h4>瓶阀校验</h4>
              </div>
            </div>
            <div class="flow-arrow">←</div>
            
            <div class="flow-item">
              <div class="flow-number">07</div>
              <div class="flow-content">
                <h4>内部干燥</h4>
              </div>
            </div>
            <div class="flow-arrow">←</div>
            
            <div class="flow-item">
              <div class="flow-number">06</div>
              <div class="flow-content">
                <h4>水压试验</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 具体检验内容及要求 Section -->
    <section class="detail-section">
      <div class="container">
        <h2 class="section-title">具体检验内容及要求</h2>
        <div class="detail-content">
          <div class="detail-item">
            <div class="detail-icon">
              <i class="el-icon-edit"></i>
            </div>
            <div class="detail-text">
              <h4>查收登记</h4>
              <p>逐只检查并登记复合气瓶制造标记和检验标记。</p>
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-icon">
              <i class="el-icon-setting"></i>
            </div>
            <div class="detail-text">
              <h4>检验准备</h4>
              <p>进行瓶阀拆除、内外表面清洗、外部清理及内部清理等，具体按GB 24161-2009 5规定执行。</p>
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-icon">
              <i class="el-icon-view"></i>
            </div>
            <div class="detail-text">
              <h4>外观检查</h4>
              <p>检查复合气瓶外观是否存在磨损、划伤、撞击损伤、分层、结构损伤、热损伤、化学品腐蚀损伤等损伤，具体按GB 24161-2009 6规定执行，并在《复合气瓶外观检查评估表》中记录检查结果。</p>
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-icon">
              <i class="el-icon-search"></i>
            </div>
            <div class="detail-text">
              <h4>内部检查</h4>
              <p>逐只检查，具体按GB 24161-2009 7规定执行，在《复合气瓶外观检查评估表》中记录缺陷存在的位置和检验结果。</p>
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-icon">
              <i class="el-icon-zoom-in"></i>
            </div>
            <div class="detail-text">
              <h4>瓶口检查</h4>
              <p>具体按GB 24161-2009 8规定执行，在《复合气瓶外观检查评估表》中记录瓶口的检查结果。</p>
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-icon">
              <i class="el-icon-data-analysis"></i>
            </div>
            <div class="detail-text">
              <h4>水压试验</h4>
              <p>具体按GB 24161-2009 9规定执行，做好试验记录。</p>
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-icon">
              <i class="el-icon-sunny"></i>
            </div>
            <div class="detail-text">
              <h4>内部干燥</h4>
              <p>经水压试验合格的复合气瓶，必须逐只进行内部干燥，具体按GB 24161-2009 10规定执行。</p>
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-icon">
              <i class="el-icon-s-tools"></i>
            </div>
            <div class="detail-text">
              <h4>瓶阀检验与安装</h4>
              <p>具体按GB 24161-2009 11规定执行。</p>
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-icon">
              <i class="el-icon-finished"></i>
            </div>
            <div class="detail-text">
              <h4>气密性试验</h4>
              <p>具体按GB 24161-2009 12规定执行。</p>
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-icon">
              <i class="el-icon-document-copy"></i>
            </div>
            <div class="detail-text">
              <h4>检验后的工作</h4>
              <p>检验标记、检验记录与报废处理要求，具体按GB 24161-2009 13规定执行。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 检验依据 Section -->
    <section class="standard-section">
      <div class="container">
        <h2 class="section-title">检验依据</h2>
        <div class="standard-content">
          <div class="standard-card">
            <div class="standard-header">
              <i class="el-icon-document"></i>
              <h3>相关标准与规程</h3>
            </div>
            <div class="standard-body">
              <ul class="standard-list">
                <li>气瓶安全技术规程 TSG 23-2021</li>
                <li>特种设备检验机构核准规则 TSG Z7001-2021</li>
                <li>气瓶水压试验方法 GB/T 9251-2022</li>
                <li>气瓶气密性试验方法 GB/T 12137-2015</li>
                <li>呼吸器用复合气瓶定期检验与评定 GB/T 24161-2009</li>
                <li>铝合金内胆碳纤维全缠绕气瓶 GB/T 28053-2023</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'GasCylinderDetection',
  methods: {
    // 后续可以添加预约检测等方法
  }
}
</script>

<style scoped>
/* 基础容器 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Hero Section */
.hero-section {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: white;
  height: 470px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to right, rgba(30, 58, 138, 0.75) 0%, rgba(59, 130, 246, 0.45) 50%, rgba(255, 255, 255, 0.20) 100%);
  z-index: 1;
}

.hero-section > .container {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.hero-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 60px;
}

.content-left {
  flex: 1;
  max-width: 520px;
}

.content-right {
  flex: 1;
  display: none;
  justify-content: center;
  align-items: flex-start;
}

.hero-image {
  position: relative;
  width: 380px;
  height: 300px;
}

.hero-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0px 20px 40px -12px rgba(0, 0, 0, 0.2);
}

.badge {
  position: absolute;
  bottom: -12px;
  right: -12px;
  display: flex;
  align-items: center;
  gap: 6px;
  background: white;
  padding: 6px 14px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.badge-icon {
  width: 14px !important;
  height: 14px !important;
  object-fit: contain;
}

.badge span {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.hero-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 38px;
  color: #ffffff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 16px;
  line-height: 26px;
  color: #e0f2fe;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.hero-description {
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 24px;
  color: #f0f9ff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.btn-primary {
  background: linear-gradient(90deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  border: none;
  padding: 10px 24px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background: linear-gradient(90deg, #1e40af 0%, #60a5fa 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.3);
}

/* 基本信息区域 */
.info-section {
  padding: 40px 0;
  background: white;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.info-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.info-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.info-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 2px solid #1e3a8a;
}

.info-header i {
  font-size: 24px;
  color: #1e3a8a;
}

.info-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.info-body p {
  font-size: 15px;
  line-height: 1.8;
  color: #1f2937;
  margin: 0;
}

/* 检验流程 Section */
.process-section {
  padding: 40px 0;
  background: #f8f9fa;
}

.section-title {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  color: #2c3e50;
}

.process-flow {
  max-width: 1100px;
  margin: 0 auto;
}

.flow-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.flow-row.reverse {
  flex-direction: row-reverse;
}

.flow-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  padding: 14px 18px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  min-width: 180px;
}

.flow-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.flow-item.final {
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
}

.flow-item.final .flow-number {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.flow-item.final .flow-content h4 {
  color: white;
}

.flow-number {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.flow-content {
  flex: 1;
}

.flow-content h4 {
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  color: #2c3e50;
}

.flow-arrow {
  font-size: 22px;
  color: #1e3a8a;
  font-weight: bold;
  flex-shrink: 0;
}

.flow-connector {
  display: flex;
  margin: 8px 0;
}

.flow-connector.right-to-right {
  justify-content: flex-end;
  padding-right: 90px;
}

.flow-connector.right-to-left {
  justify-content: flex-start;
  padding-left: 90px;
}

.connector-arrow {
  font-size: 26px;
  color: #1e3a8a;
  font-weight: bold;
}

/* 具体检验内容区域 */
.detail-section {
  padding: 40px 0;
  background: white;
}

.detail-content {
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.detail-item {
  display: flex;
  gap: 16px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #1e3a8a;
  transition: all 0.3s ease;
}

.detail-item:hover {
  transform: translateX(5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.detail-icon {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.detail-icon i {
  font-size: 22px;
  color: white;
}

.detail-text h4 {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 8px 0;
}

.detail-text p {
  font-size: 15px;
  line-height: 1.8;
  color: #606266;
  margin: 0;
}

/* 检验依据 Section */
.standard-section {
  padding: 40px 0;
  background: #f8f9fa;
}

.standard-content {
  max-width: 900px;
  margin: 0 auto;
}

.standard-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.standard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.standard-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1e3a8a;
}

.standard-header i {
  font-size: 28px;
  color: #1e3a8a;
}

.standard-header h3 {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.standard-body {
  padding: 0;
}

.standard-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.standard-list li {
  font-size: 16px;
  line-height: 1.8;
  color: #1f2937;
  padding-left: 24px;
  position: relative;
}

.standard-list li::before {
  content: '•';
  position: absolute;
  left: 8px;
  color: #1e3a8a;
  font-size: 20px;
  font-weight: bold;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .info-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .flow-item {
    min-width: 160px;
    padding: 14px 16px;
  }

  .flow-content h4 {
    font-size: 14px;
  }

  .flow-number {
    width: 32px;
    height: 32px;
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .hero-section {
    height: auto;
    min-height: 400px;
    padding: 80px 0 40px;
  }

  .hero-content {
    flex-direction: column;
    gap: 40px;
  }

  .content-left {
    max-width: 100%;
  }

  .content-right {
    width: 100%;
  }

  .hero-image {
    width: 100%;
    max-width: 400px;
    height: auto;
    aspect-ratio: 4/3;
  }

  .hero-title {
    font-size: 28px;
    line-height: 1.3;
    margin-bottom: 16px;
  }

  .hero-subtitle {
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 16px;
  }

  .hero-description {
    font-size: 14px;
    line-height: 1.6;
    display: none;
  }

  .btn-primary {
    width: 100%;
    padding: 12px 24px;
  }

  .badge {
    bottom: -12px;
    right: -12px;
    padding: 6px 12px;
  }

  .badge span {
    font-size: 14px;
  }

  .badge-icon {
    width: 14px !important;
    height: 14px !important;
  }

  .section-title {
    font-size: 24px;
    margin-bottom: 30px;
  }

  .info-section,
  .process-section,
  .detail-section,
  .standard-section,
  .review-section,
  .sample-section {
    padding: 40px 0;
  }

  .info-card {
    padding: 24px;
  }

  .info-header i {
    font-size: 20px;
  }

  .info-header h3 {
    font-size: 16px;
  }

  .info-body p {
    font-size: 14px;
  }

  .process-flow {
    padding: 0 15px;
    max-width: 100%;
  }

  .flow-row {
    flex-direction: column !important;
    gap: 0 !important;
    width: 100%;
    align-items: stretch;
  }

  .flow-row.reverse-desktop {
    flex-direction: column-reverse !important;
  }

  .flow-arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 8px 0;
    height: 24px;
    font-size: 0 !important;
  }

  .flow-arrow::after {
    content: '↓';
    font-size: 24px;
    color: #1890ff;
    line-height: 1;
  }

  .flow-connector {
    display: flex;
    justify-content: center !important;
    align-items: center;
    width: 100%;
    padding: 0 !important;
    margin: 8px 0;
    height: 24px;
  }

  .flow-connector.right-to-right,
  .flow-connector.left-to-left {
    justify-content: center !important;
    padding: 0 !important;
  }

  .connector-arrow {
    font-size: 24px;
    color: #1890ff;
    line-height: 1;
  }

  .flow-item {
    min-width: auto !important;
    width: 100%;
    max-width: 100%;
    padding: 12px 14px;
    gap: 10px;
    margin: 5px 0;
    box-sizing: border-box;
  }

  .flow-number {
    width: 32px;
    height: 32px;
    font-size: 13px;
  }

  .flow-content h4 {
    font-size: 14px;
  }

  .detail-item {
    padding: 20px;
    gap: 16px;
  }

  .detail-icon {
    width: 40px;
    height: 40px;
  }

  .detail-icon i {
    font-size: 20px;
  }

  .detail-text h4 {
    font-size: 16px;
  }

  .detail-text p {
    font-size: 14px;
  }

  .standard-card {
    padding: 24px;
  }

  .standard-header {
    margin-bottom: 20px;
    padding-bottom: 12px;
  }

  .standard-header i {
    font-size: 24px;
  }

  .standard-header h3 {
    font-size: 18px;
  }

  .standard-list {
    gap: 12px;
  }

  .standard-list li {
    font-size: 15px;
    line-height: 1.6;
    padding-left: 20px;
  }

  .standard-list li::before {
    font-size: 18px;
    left: 6px;
  }

  .review-grid,
  .sample-grid {
    grid-template-columns: 1fr;
  }
}
</style>
